import { render, staticRenderFns } from "./BaseNavDropdown.vue?vue&type=template&id=15a49170&scoped=true&"
import script from "./BaseNavDropdown.vue?vue&type=script&lang=js&"
export * from "./BaseNavDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BaseNavDropdown.vue?vue&type=style&index=0&id=15a49170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a49170",
  null
  
)

export default component.exports